<script setup lang="ts">
import { RouterView } from 'vue-router'

import { useOrdersStore } from './stores/orders'
import { onMounted } from 'vue'
import { usePusher } from '@/composables/usePusher'
import { toast } from 'vue3-toastify'

const pusher = usePusher()

onMounted(() => {
  const ordersStore = useOrdersStore()
  if (pusher != null) {
    // Orders channel
    const ordersChannel = pusher.subscribe('table-orders')
    ordersChannel.bind('new-order', (data: any) => {
      if (ordersStore.orders.some((order) => order.id == data.id)) return
      const tablenumMeta = data.meta_data?.find((meta: any) => meta.key === 'tablenum')
      const tableNumber = tablenumMeta ? tablenumMeta.value : 'غير معروف'
      toast.success(`تم اضافة طلب جديد - طاولة رقم ${tableNumber}`)

      ordersStore.orders.unshift(data)
    })

    // Notifications channel
    const notificationChannel = pusher.subscribe('noti')

    notificationChannel.bind('newnot', (data: any) => {
      const table = data.tablenum
      toast.success(`طاولة رقم ${table} طلبت المساعدة`)
    })

    notificationChannel.bind('newtable', (data: any) => {
      const table = data.tablenum
      if (table != '999999') {
        toast.success(`طاولة رقم ${table} قامت بمسح الرمز`)
      }
    })
  }
})
</script>
<template>
  <RouterView />
</template>
